import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=bcb5e69a&scoped=true"
import script from "./tongji.vue?vue&type=script&lang=js"
export * from "./tongji.vue?vue&type=script&lang=js"
import style0 from "./tongji.vue?vue&type=style&index=0&id=bcb5e69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb5e69a",
  null
  
)

export default component.exports